import PropTypes from 'prop-types';

// material-ui
import { styled } from '@mui/material/styles';
import { Box, Button, Grid, Typography } from '@mui/material';

// third-party

// project imports
import MainCard from 'ui-component/cards/MainCard';
import SkeletonTotalOrderCard from 'ui-component/cards/Skeleton/EarningCard';
import { Stack } from '@mui/system';



// assets

const CardWrapper = styled(MainCard)(() => ({
  background: "linear-gradient(45deg, #511E6C, #6E328D)",
  color: '#fff',
  overflow: 'hidden',
  position: 'relative',
  '&>div': {
    position: 'relative',
    zIndex: 5
  }
}));

// ==============================|| DASHBOARD - TOTAL ORDER LINE CHART CARD ||============================== //

const TotalOrderLineChartCard = (props,{ isLoading }) => {



  return (
    <>
      {isLoading ? (
        <SkeletonTotalOrderCard />
      ) : (
        <CardWrapper border={false} content={false}>
          <Box sx={{ p: 2.25 }}>
            <Grid container direction="column">
              <Grid item>
                <Grid container justifyContent="space-between">
                  <Grid item xl={12}>
                    <Typography variant="h4" color="#E3F1C5">Sign On Wallet</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item sx={{ mb: 0.75 }}>
                <Grid container alignItems="center">
                  <Grid item xs={12}>
                    <Grid container alignItems="center">

                      <Grid item xl={6} textAlign='left'>
                        <Typography sx={{ fontSize: '2.125rem', fontWeight: 500, mt: 1.75, mb: 0.75 }} color="#CDF726">₹{props.summaryData?props.summaryData.wallet_balances.sign_on_wallet_balance:"0"}</Typography>
                      </Grid>
                    </Grid>
                  </Grid>

                </Grid>
              </Grid>

              <Grid item xl={12} justifyContent='flex-end' alignItems='flex-end'>
              <Stack direction='row' alignItems='center' justifyContent='space-between'>
                  <Typography variant='body1'>Compared to ₹ 0 Last Month</Typography>
                  <Button variant='outlined' size='small' sx={{
                    backgroundColor: '#fff', border: 'none', color: '#6A2F88', '&:hover': {
                      backgroundColor: '#f1f1f1',
                      color: '#6A2F88',
                      border: 'none',
                    },
                    
                  }}
                  onClick={()=>props.handleAddType("sign_on")}
                  >Add Money</Button>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </CardWrapper>
      )}
    </>
  );
};

TotalOrderLineChartCard.propTypes = {
  isLoading: PropTypes.bool
};

export default TotalOrderLineChartCard;
